import { render } from "./CarDialog.vue?vue&type=template&id=0da36482"
import script from "./CarDialog.vue?vue&type=script&lang=js"
export * from "./CarDialog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__